import React, { useRef } from "react";
import { fileUpload } from "../../utils/utils";
import { Button } from "primereact/button";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import useSaveEconomicIndicator from "./hooks/useSaveEconomicIndicator";
import { Messages } from "primereact/messages";

function EconomicIndicators(props) {
  let section = props.section;
  const mutation = useSaveEconomicIndicator();
  const msgRef = useRef();
  const loading = props.loading;

  async function handleImageUpload(e, section) {
    let imagePath = await fileUpload(e.target.files[0], section);
    props.updateImagePath(section, imagePath, "");
  }

  function handleSectionSave() {
    mutation.mutate(
      {
        ...section,
        reportDate: props.reportDate,
        regionId: props.regionId,
        productLineId: props.productLineId,
      },
      {
        onSuccess: (data) => {
          if (msgRef.current) {
            msgRef.current.clear();
            msgRef.current.show([
              {
                sticky: false,
                severity: "success",
                summary: "Success",
                detail: "Economic Indicator saved successfully",
                closable: false,
                life: 2000,
              },
            ]);
          }
          props.updateSectionId("economicIndicators", data.data);
          mutation.reset();
        },
        onError: () => {
          if (msgRef.current) {
            msgRef.current.clear();
            msgRef.current.show([
              {
                sticky: true,
                severity: "error",
                summary: "Error",
                detail: "Error saving Economic Indicator",
                closable: true,
              },
            ]);
          }
          mutation.reset();
        },
      }
    );
  }
  return (
    <div className='relative syndication__section__wrapper sa_ecnomic_indicator'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          marginBottom: "10px",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td valign='top' align='left'>
              <div>Economic Indicators</div>
              {section.imagePath !== "" ? (
                <div>
                  <img
                    alt='Economic Indicator Img'
                    width={800}
                    height={100}
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      height: "100px",
                    }}
                    src={decodeURIComponent(encodeURIComponent(section.imagePath))}
                  />
                  {props.publish === false && props.diff_date >= 0 ? (
                    <>
                      <button
                        className='RemoveImage diag-save-button floatRight'
                        style={{
                          borderRadius: "35px",
                          margin: "8px",
                          textAlign: "center",
                          padding: "10px",
                          color: "#FFFFFF",
                          boxSizing: "border-box",
                          backgroundColor: "#199B8B",
                        }}
                        onClick={() => {
                          props.updateImagePath(section, "", "");
                        }}
                      >
                        Remove image
                      </button>
                      <Button
                        pt={{ label: { className: "mx-0" } }}
                        className='p-button p-button-sm diag-save-button savesectionbtn'
                        label='Save Section Content'
                        onClick={() => handleSectionSave()}
                      />
                    </>
                  ) : null}
                </div>
              ) : (
                <div>
                  Select an image
                  <div>
                    <input
                      type='file'
                      name='file'
                      onChange={(e) => {
                        handleImageUpload(e, section);
                      }}
                    />
                    <Button
                      pt={{ label: { className: "mx-0" } }}
                      className='p-button p-button-sm diag-save-button savesectionbtn'
                      label='Save Section Content'
                      onClick={() => handleSectionSave()}
                    />
                  </div>
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
    </div>
  );
}

export default EconomicIndicators;
